import * as Yup from 'yup';
export const initialChildValues = {
    allergies: '',
    disabilities: '',
    otherHealthConditions: '',
    languageId: '',
};
export const childSchema = Yup.object().shape({
    allergies: Yup.string(),
    disabilities: Yup.string(),
    otherHealthConditions: Yup.string(),
});
//# sourceMappingURL=child.js.map